<template>
  <v-container>
    <v-row justify="center">
      <v-col sm="12" md="10" lg="8">
        <v-card>
          <v-card-title>
            <v-icon left>fas fa-cube</v-icon>
            All Project Batches
          </v-card-title>
          <BatchesTable
            :search="search"
            :is-detail="true"
            :batches="batches"
            :loading="false"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Batch from "../../models/Batch";
import BatchesTable from "../../components/Batch/BatchesTable";
export default {
  name: "ProjectBatchListView",
  components: { BatchesTable },
  props: {
    id: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      search: ""
    }
  },
  computed: {
    batches() {
      return Batch.query()
        .where("project", parseInt(this.id))
        .with("location")
        .get();
    }
  }
}
</script>
